import windowSize from "get-window-size";

const UserAgent = {
  state: {
    window: {
      width: windowSize().width,
      height: windowSize().height,
    },
    orientation: null,
    isScrollLock: false,
    browser: null
  },
  mutations: {
    DETECT_ORIENTATION(state, payload) {
      if (payload) {
        state.orientation = "landscape";
      } else {
        state.orientation = "portrait";
      }
    },
    UPDATE_WINDOW_SIZE(state) {
      state.window.width = windowSize().width;
      state.window.height = windowSize().height;
    },
    UPDATE_LOCK_STATE: (state, payload) => {
      state.isScrollLock = payload;
    },
    UPDATE_BROWSER: (state, payload) => {
      state.browser = payload;
    }
  },
};

export default UserAgent;
